import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React, { Component } from "react";

import PageCardHeader from "./PageCardHeader";

class PageCard extends Component {
  render() {
    return (
      <div
        style={({
          ...this.props.style,
          width: "100%",
          boxSizing: "border-box",
          padding: this.props.cardPadding ? this.props.cardPadding : "24px",
        })}
      >
        <Card
          style={{
            width: "100%",
            overflow: this.props.overflow ? this.props.overflow : null,
          }}
          square={this.props.square}
        >
          {!this.props.disableHeader && (
            <PageCardHeader
              title={this.props.title}
              action={this.props.action && this.props.action()}
              overloadedClasses={this.props.overloadedHeaderClasses}
              titleTypographyProps={this.props.titleTypographyProps}
              renderBackButton={this.props.renderBackButton}
              renderContinue={this.props.renderContinue}
              withImageCardHeader={this.props.withImageCardHeader}
              avatar={this.props.avatar}
            />
          )}
          {this.props.subHeader}
          <CardContent
            style={{
              padding: this.props.contentPadding
                ? this.props.contentPadding
                : "24px",
            }}
          >
            {this.props.children}
          </CardContent>
          {this.props.footerVisible && (
            <CardContent
              style={{ padding: 0, height: 85, backgroundColor: "#F5F5F5" }}
            >
              {this.props.footer}
            </CardContent>
          )}
        </Card>
      </div>
    );
  }
}

PageCard.defaultProps = {
  square: false,
};

export default PageCard;
